<ng-container *ngFor="let item of formData">
    <div class="name">
        {{ item.label }}
    </div>
    <div class="input">
        <app-component-users-multiselect (value)="userList($event)"
                                         [sendObject]="true"></app-component-users-multiselect>
    </div>
</ng-container>
